<template>
  <div class="activity-osten-home">
    <div class="activity-osten-main">
    <header class="header">
      <div class="header__logo-wrap">
        <img class="header__logo" :src="cdnLogo" alt="" />
      </div>
      <div class="header__titles">
        <div class="header__line1">{{ $t('osten.home.title_line1') }}</div>
        <div class="header__line2">{{ $t('osten.home.title_line2') }}</div>
      </div>
    </header>

    <div class="switch">
      中文
      <van-switch
        style="margin: 0 12px;"
        size="24"
        v-model="checked"
        active-color="#1F57A7"
        inactive-color="#e8ecf2"
        @change="switchLanguage"
      />
      EN
    </div>

    <button type="button" class="opening-btn" @click="handlePrimaryClick">
      {{ $t('osten.home.opening_ceremony') }}
    </button>

    <div class="sport-grid">
      <button
        v-for="item in sportList"
        :key="item.id"
        type="button"
        class="sport-card"
        @click="handleItemClick(item)"
      >
        <img class="sport-card__icon" :src="item.icon" alt="" />
        <div class="sport-card__label">
          {{ $t(`osten.home.${item.id}`) }}
        </div>
      </button>
    </div>
    </div>

    <section class="partners" aria-label="sponsors" v-if="false">
      <div class="partners__grid">
        <div
          v-for="(url, index) in sponsorUrls"
          :key="index"
          class="partners__item"
        >
          <img class="partners__logo" :src="url" alt="" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import { Switch } from 'vant'
import { getToken } from '@/libs/cookie-storage'

Vue.use(Switch)

/** 素材 CDN：https://images.snsports.cn/osten-*.png */
const OSTEN_CDN = 'https://images.snsports.cn'

/** match-h5 外链（完整 URL，走 window.location） */
const MATCH_H5 = 'https://www.snsports.cn/match-h5/index.html'

export default {
  name: 'ActivityOstenHome',
  data() {
    return {
      cdnLogo: `${OSTEN_CDN}/osten-icon.png`,
      sponsorUrls: Array.from({ length: 7 }, (_, i) => `${OSTEN_CDN}/osten-sponsor${i + 1}.png`),
      checked: this.$i18n.locale === 'en',
      /** 开幕式：直播页 */
      primaryPath:
        `${MATCH_H5}#/live-page/3667882`,
      sportList: [
        {
          id: 'sport_gymnastics',
          path: '/activity-osten/sub/gymnastics',
          icon: `${OSTEN_CDN}/osten-gymnastics.png`
        },
        {
          id: 'sport_basketball',
          path: '/activity-osten/sub/basketball',
          icon: `${OSTEN_CDN}/osten-basketball.png`
        },
        {
          id: 'sport_football',
          path: '/activity-osten/sub/football',
          icon: `${OSTEN_CDN}/osten-football.png`
        },
        {
          id: 'sport_swimming',
          path: `${MATCH_H5}#/live-page/3667883`,
          icon: `${OSTEN_CDN}/osten-swimming.png`
        },
        {
          id: 'sport_athletics',
          path: `${MATCH_H5}#/live-page/3667642`,
          icon: `${OSTEN_CDN}/osten-tf.png`
        },
        {
          id: 'sport_volleyball',
          path: `${MATCH_H5}#/match/home?matchId=61229`,
          icon: `${OSTEN_CDN}/osten-volleyball.png`
        }
      ]
    }
  },
  mounted() {
    window.localStorage.setItem('activityOsten', 'activity-osten')
  },
  methods: {
    switchLanguage(value) {
      const language = value ? 'en' : 'zh'
      this.$i18n.locale = language
      localStorage.setItem('language', language)
    },
    handlePrimaryClick() {
      this.navigateByPath(this.primaryPath)
    },
    handleItemClick(item) {
      this.navigateByPath(item.path)
    },
    navigateByPath(path) {
      if (path && String(path).includes('http')) {
        window.location.href = path
        return
      }
      /** 活动站内二级页，无需登录 */
      if (path && String(path).startsWith('/activity-osten')) {
        this.$router.push({ path })
        return
      }
      const passport = getToken()
      if (!path) {
        this.$toast(
          '功能暂未上线，敬请期待\nThis feature is not yet available.'
        )
        return
      }
      if (passport) {
        this.$router.push({ path })
      } else {
        let redirect = window.location.hash
        redirect = redirect.substring(1)
        this.$router.push({
          path: `/jetlympic/login?redirect=${encodeURIComponent(redirect)}`
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.activity-osten-home {
  min-height: 100vh;
  box-sizing: border-box;
  background: #ffffff;
  color: #3d3d3d;
  position: relative;
}

.activity-osten-main {
  box-sizing: border-box;
  padding: 16px 14px 0;
  /* 为底部固定赞助商区预留空间（约两行 logo + 内边距） */
  padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
}

.header {
  display: flex;
  // align-items: center;
  gap: 12px;
}

.header__logo-wrap {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff;
}

.header__logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.header__titles {
  flex: 1;
  min-width: 0;
  padding-top: 12px;
}

.header__line1 {
  font-size: 16px;
  font-weight: 500;
  color: #3d3d3d;
  letter-spacing: 0.02em;
  line-height: 1.25;
}

.header__line2 {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #3d3d3d;
  letter-spacing: 0.02em;
  line-height: 1.25;
}

.switch {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 14px;
  font-size: 18px;
  font-weight: 500;
  color: #1F57A7;
}

.opening-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  margin-top: 18px;
  padding: 0 16px;
  border: 2px solid #1f57a7;
  border-radius: 12px;
  background: #ffffff;
  box-sizing: border-box;
  color: #1f57a7;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.opening-btn:active {
  opacity: 0.85;
}

.sport-grid {
  display: grid;
  grid-template-columns: repeat(3, 109px);
  gap: 10px;
  justify-content: center;
  margin-top: 18px;
}

.sport-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 109px;
  height: 122px;
  padding: 8px 6px 10px;
  border: 2px solid #1f57a7;
  border-radius: 12px;
  background: #ffffff;
  box-sizing: border-box;
  cursor: pointer;
}

.sport-card:active {
  opacity: 0.88;
}

.sport-card__icon {
  height: 60px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  flex-shrink: 0;
}

.sport-card__label {
  margin-top: 6px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #1f57a7;
  line-height: 1.25;
  word-break: break-word;
}

.partners {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 24px;
  z-index: 10;
  padding: 12px 14px calc(12px + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
  box-sizing: border-box;
}

.partners__grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px 8px;
}

.partners__item {
  width: 80px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.partners__logo {
  height: 45px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
}

:deep(.van-switch__node) {
  background-color: #ffffff;
}
</style>
